<template>
  <div style="padding-top:-2px;margin-top:-2px;">
    <v-label v-if="label"><b>{{ label }}</b></v-label>
    <s-select-generic
      ref="sgeneric"
      autocomplete
      :config="config"
      :disabled="disabled"
      :readonly="readonly"
      :itemvalue="id"
      :itemtext="itemText"
      :clearable="clearable"
      :full="full"
      :id="id"
      :value="value"
      @input="input($event)"
      :returnObject="returnObject"
    />
  </div>
</template>

<script>
import Vue from "vue";

export default {
  name: "SSelectEducationalMajor",
  props: {
    id: {
      type: String,
      default: "EdmCode",
    },
    itemText: {
      type: String,
      default: "EdmDescription",
    },
    value: null,
    label: {
      type: String,
      default: "Carrera Profesional",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    returnObject: {
      type: Boolean,
      default: false,
    },
    full: {
      type: Boolean,
      default: true,
    },
    ediCode: {
      type: [String, Number],
      default: null,
    }
  },
  data() {
    return {
      config: {
        url: Vue.prototype.$http.defaults.baseURL + "/HmnEducationalMajor/list",
        title: "",
        params: {
          requestID: 0,
          ediCode: null
        },
      },
    };
  },
  watch: {
    ediCode: {
      handler(val) {
        this.config.params.ediCode = val;
      },
      immediate: true
    }
  },
  methods: {
    input(item) {
      this.$emit("input", item);
    },
  },
  created() {
    this.config.title = this.label;
    this.config.params.requestID = this.$fun.getUserID();
  },
};
</script>
